export default __webpack_public_path__ + "d66c2a9cdd4abe48502b7a3c86ca1dac.svg";